import axios, { AxiosResponse } from 'axios';

type DateTimeString = string;

export enum ECrsStav {
    ROZP = 'ROZP',
    ZPRAC = 'ZPRAC',
    ZRUS = 'ZRUS'
}

export enum ECrsStatus {
    STS1 = 'STS1',
    STS1A = 'STS1A',
    STS1B = 'STS1B',
    STS2 = 'STS2',
    STS3 = 'STS3',
    STS3A = 'STS3A',
    STS3B = 'STS3B',
    STS3C = 'STS3C',
    STS3D = 'STS3D',
    STS3E = 'STS3E',
    STS4 = 'STS4'
}

export interface ICrsDotaznik {
    iddot: number;
    subjektoid: number;
    stav: ECrsStav;
    poslstav: boolean;
    stat: string;
    statut?: ECrsStatus;
    osobycr: boolean;
    dic: string;
    giin?: string;
}

export const crsDotaznikZalozit = async () => {
    const resp = await axios<{ id: number }>({
        method: 'POST',
        url: '/CRS/zalozit'
    });

    return resp.data;
};
export const crsDotaznikSend = async (method: 'POST' | 'PUT', data?: ICrsDotaznik, id?: number) => {
    const resp = await axios<{ id: number }>({
        method,
        url: `/CRS/${id}/dotaznik`,
        data
    });

    return resp.data;
};

export const crsDotaznikGet = async (id: number) => {
    const resp: AxiosResponse<ICrsDotaznik> = await axios({
        method: 'GET',
        url: `/CRS/${id}/dotaznik/`
    });
    return resp.data;
};

export interface ICrsSpolecnost {
    idma: string;
    idmb: string;
    dphplatce: boolean;
    dphdic?: string;
    lei: string;
    nazev: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
    madoruc: boolean;
    advy: string;
    mevy: string;
    psvy: string;
    ksvy: string;
    spolstaty: { stat: string }[];
}

export const crsSpolecnostSend = async (data: ICrsSpolecnost, id: number) => {
    const resp = await axios({
        method: 'PUT',
        url: `/CRS/${id}/spol`,
        data
    });

    return resp.data;
};

export const crsSpolecnostGet = async (id: number) => {
    const resp: AxiosResponse<ICrsSpolecnost> = await axios({
        method: 'GET',
        url: `/CRS/${id}/spol/`
    });
    return resp.data;
};

export enum ECrsTypOsoby {
    CRS801 = 'CRS801',
    CRS802 = 'CRS802',
    CRS803 = 'CRS803',
    CRS804 = 'CRS804',
    CRS805 = 'CRS805',
    CRS806 = 'CRS806',
    CRS807 = 'CRS807',
    CRS808 = 'CRS808',
    CRS809 = 'CRS809',
    CRS810 = 'CRS810',
    CRS811 = 'CRS811',
    CRS812 = 'CRS812',
    CRS813 = 'CRS813'
}

export interface ICrsOsoba {
    typ: ECrsTypOsoby;
    jmeno: string;
    prijmeni: string;
    stat: string;
    datumnar: DateTimeString;
    misto: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
    madoruc: true;
    advy: string;
    mevy: string;
    psvy: string;
    ksvy: string;
    id: number;
    osobastaty: {
        stat: string;
    }[];
    osobazeme: {
        stat: string;
        dic: string;
        dicduvod: string;
    }[];
}

export const crsOsobaSend = async (method: 'POST' | 'PUT', data: ICrsOsoba, id: number, idOsoba?: number) => {
    const resp = await axios({
        method,
        url: `/CRS/${id}/osoba/${idOsoba ? idOsoba : ''}`,
        data
    });

    return resp.data;
};

export const crsOsobaGet = async (id: number, idOsoba: number) => {
    const resp: AxiosResponse<ICrsOsoba> = await axios({
        method: 'GET',
        url: `/CRS/${id}/osoba/${idOsoba}`
    });

    return resp.data;
};

export const crsOsobaDelete = async (id: number, idOsoba: number) => {
    const resp: AxiosResponse<ICrsOsoba> = await axios({
        method: 'DELETE',
        url: `/CRS/${id}/osoba/${idOsoba}`
    });

    return resp.data;
};

export const crsOsobyGet = async (id: number) => {
    const resp: AxiosResponse<{ osoby: ICrsOsoba[] }> = await axios({
        method: 'GET',
        url: `/CRS/${id}/osoby`
    });

    return resp.data;
};

export interface ICrsHistorieDotaznik {
    iddot: number;
    datum: DateTimeString;
    stav: ECrsStav;
    lastid?: number;
}

export interface ICrsHistorie {
    count: number;
    order: string;
    limit: number;
    offset: number;
    dotazniky: ICrsHistorieDotaznik[];
    dotaznik: ICrsHistorieDotaznik;
    lastid: number;
}

export interface ICrsHistorieInput {
    order: string;
    offset: number;
    limit: number;
}

export const crsHistorieGet = async (params: ICrsHistorieInput) => {
    const resp: AxiosResponse<ICrsHistorie> = await axios({
        method: 'GET',
        url: '/CRS/historie',
        params
    });

    return resp.data;
};

export const crsZruseni = async (id: number) => {
    const resp: AxiosResponse<ICrsHistorie> = await axios({
        method: 'POST',
        url: `/CRS/${id}/zrusit`
    });

    return resp.data;
};

export const crsPDFdownload = (id: number, name: string) => {
    return axios({
        method: 'GET',
        url: `/CRS/${id}/pdf`,
        responseType: 'blob' // important
    }).then((resp: { status: number; data: any }) => {
        if (resp.status === 200) {
            // způsob, jak stažený dokument otevřít v browseru
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nav = window.navigator as any;
            // IE
            if (nav?.msSaveOrOpenBlob) {
                nav.msSaveOrOpenBlob(resp.data, name);
            } else {
                const odp = resp.data;

                const uriContent = URL.createObjectURL(
                    new Blob([odp], {
                        type: 'application/octetstream'
                    })
                );
                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = name;
                link.href = uriContent;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    });
};
